// @flow
// @flow-runtime warn
import { createContext } from 'react';


type ShopCartContextType = [[string, boolean], {
  cartRequest: () => Promise<void> | void,
  newCart: () => Promise<void> | void,
  handlePeriodicUpdate: () => Promise<void> | void,
}]

const defaultContext: ShopCartContextType = [['', true], {
  cartRequest: () => {},
  newCart: () => {},
  handlePeriodicUpdate: () => {},
}];

export default createContext<ShopCartContextType>(defaultContext);
